import type { Price } from '../../../../ssr/src/Outlet/ShoppingCart/ShoppingCartSchema';
import type { GiftCardProps } from '../Upsell/state';

interface CartItem {
  amount: number;
  amountMutable: boolean;
  copyPersonalisationUrl: string | null;
  displayAmount: string;
  editUrl: string;
  giftCard: GiftCardProps;
  id: string;
  isAlcohol: boolean;
  isDiscounted: boolean;
  isStrongAlcohol: boolean;
  name: string;
  originalPrice: Price;
  previewImage: string;
  price: Price;
  productId: number;
  productUrl: string;
  shippingText: string;
}

interface CartItemState {
  cartContainsAlcohol: boolean;
  cartContainsStrongAlcohol: boolean;
  items: Record<string, CartItem>;
}

const initialCartItemState: CartItemState = {
  cartContainsAlcohol: false,
  cartContainsStrongAlcohol: false,
  items: {},
};

export type { CartItemState, CartItem };
export default initialCartItemState;
